var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345,256c0,22.3-39.9,77.9-89,77.9s-89-55.7-89-77.9c0-49.2,39.9-89,89-89S345,206.8,345,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M345,256c0,49.2-39.9,89-89,89s-89-39.9-89-89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350.4,334.7l23.6-23.6l15.7,15.7l-23.6,23.6L350.4,334.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311,374.1l23.6-23.6l15.7,15.7l-23.6,23.6L311,374.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M397.6,381.9l23.6-23.6l15.7,15.7l-23.6,23.6L397.6,381.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.2,421.3l23.6-23.6l15.7,15.7L374,437L358.2,421.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M374,358.3l23.6-23.6l15.7,15.7l-23.6,23.6L374,358.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.6,397.7l23.6-23.6l15.7,15.7l-23.6,23.6L334.6,397.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M397.7,177.3l-63-63l15.7-15.7l63,63L397.7,177.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M334.7,161.6L311.1,138l15.7-15.7l23.6,23.6L334.7,161.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M374.1,201l-23.6-23.6l15.7-15.7l23.6,23.6L374.1,201z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.9,114.4l-23.6-23.6L374.1,75l23.6,23.6L381.9,114.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M421.3,153.7l-23.6-23.6l15.7-15.7L437,138L421.3,153.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8,358.3l63,63L138,437l-63-63L90.8,358.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.7,374l23.6,23.6l-15.7,15.7L138,389.7L153.7,374z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.4,334.7l23.6,23.6L122.2,374l-23.6-23.6L114.4,334.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138,311l63,63l-15.7,15.7l-63-63L138,311z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.7,90.7l-63,63L75,137.9l63-63L153.7,90.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3,114.3l-63,63l-15.7-15.7l63-63L177.3,114.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.9,138l-63,63l-15.7-15.7l63-63L200.9,138z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.258b0f5b526bc8a0de9774be722482b8.svg";
export { ForwardRef as ReactComponent };